import React from 'react'
import { Create, SimpleForm, TextInput, SelectInput, BooleanInput, ReferenceInput, AutocompleteInput, NumberInput } from 'react-admin'
import { Box, Typography } from '@mui/material'
import { Create as CreateWrapper } from '../common/views'

const leadStatusChoices = [
  { id: 'new', name: 'New' },
  { id: 'contacted', name: 'Contacted' },
  { id: 'qualified', name: 'Qualified' },
  { id: 'meeting_scheduled', name: 'Meeting Scheduled' },
  { id: 'proposal_sent', name: 'Proposal Sent' },
  { id: 'converted', name: 'Converted' },
  { id: 'unqualified', name: 'Unqualified' },
  { id: 'lost', name: 'Lost' },
  { id: 'nurturing', name: 'Nurturing' },
]

const leadSourceChoices = [
  { id: 'typeform', name: 'Typeform' },
  { id: 'referral', name: 'Referral' },
  { id: 'linkedin', name: 'LinkedIn' },
  { id: 'user', name: 'Manual' },
  { id: 'other', name: 'Other' },
]

const LeadCreate = (props) => (
  <CreateWrapper {...props}>
    <SimpleForm>
      {/* Lead Status */}
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <SelectInput
          source="status"
          label="Status"
          choices={leadStatusChoices}
          defaultValue="new"
          fullWidth
        />
        <SelectInput
          source="source"
          label="Source"
          choices={leadSourceChoices}
          defaultValue="user"
          fullWidth
        />
      </Box>

      {/* Contact Information */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 2 }}>
        Contact Information
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput
          source="first_name"
          label="First Name"
          fullWidth
          validate={(value) => (!value ? 'First name is required' : undefined)}
        />
        <TextInput
          source="last_name"
          label="Last Name"
          fullWidth
          validate={(value) => (!value ? 'Last name is required' : undefined)}
        />
        <TextInput
          source="email"
          label="Email"
          fullWidth
          type="email"
          validate={(value) => (!value ? 'Email is required' : undefined)}
        />
        <TextInput source="phone" label="Phone" fullWidth />
        <TextInput source="mobile" label="Mobile" fullWidth />
        <TextInput source="company" label="Company" fullWidth />
        <TextInput source="job_title" label="Job Title" fullWidth />
        <TextInput source="department" label="Department" fullWidth />
        <TextInput source="website" label="Website" fullWidth />
        <TextInput source="linkedin_url" label="LinkedIn Profile URL" fullWidth />
      </Box>

      {/* Lead Details */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Lead Details
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput source="campaign" label="Campaign" fullWidth />
        <BooleanInput source="marketing_consent" label="Marketing Consent" defaultValue={true} />
      </Box>

      {/* Project Information */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Project Information
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput
          source="project_description"
          label="Project Description (What)"
          multiline
          fullWidth
          rows="3"
        />
        <TextInput
          source="project_reason"
          label="Project Reason (Why)"
          multiline
          fullWidth
          rows="3"
        />
        <TextInput
          source="project_location"
          label="Project Location (Where)"
          fullWidth
        />
        <TextInput
          source="project_timeline"
          label="Project Timeline (When)"
          multiline
          fullWidth
          rows="2"
        />
        <TextInput
          source="project_budget"
          label="Project Budget"
          multiline
          fullWidth
          rows="2"
        />
      </Box>

      {/* Financial */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Financial
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <NumberInput source="expected_revenue" label="Expected Revenue" fullWidth />
      </Box>
    </SimpleForm>
  </CreateWrapper>
)

export default LeadCreate
